module.exports = __webpack_public_path__ + "assets/4257a366ce87208775ae077781037ff8.png";